import React, { Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './global/auth/components/Login'
import PrivateRoute from './global/auth/components/PrivateRoute'
import AppContextProvider from './global/index'
import ErrorHandler from './global/diags/components/ErrorHandler'
import Alert from './global/diags/components/Alert'
import Sentry from './global/diags/components/Sentry'
import GoogleAnalytics from './global/diags/components/GoogleAnalytics'
import AppLoading from './global/diags/components/AppLoading'
import Intercom from './global/diags/components/Intercom'
import * as SentryClient from '@sentry/react'
import Default from './global/diags/components/Default'
import { Window } from './modules/types'
import NotFound404 from './global/nav/components/NotFound404'
import PartnerRoutes from './modules/partner/components'
import AdminRoutes from './modules/account/components'
import SuspenseFallback from './components/layout/SuspenseFallback'
import './App.css'
import Confirm from './components/modal/Confirm'

function Routes() {
  return (
    <Router>
      <Alert />
      <Confirm />
      {process.env.REACT_APP_GA_TRACKING_ID && (
        <GoogleAnalytics />
      )}
      
      <ErrorHandler />

      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute exact path="/" component={Default} />
        <PrivateRoute path="/account/:accountId" component={AdminRoutes} />
        <PrivateRoute path="/partner/:partnerId" component={PartnerRoutes} />
        <Route exact component={NotFound404} />
      </Switch>
    </Router>
  )
}

function App() {
  try {
    return (
      <AppContextProvider>
        {!(window as Window).Cypress && (
          <>
            <Sentry />
            <Intercom />
          </>
        )}

        <AppLoading />
        <Suspense fallback={<SuspenseFallback />}>
          <Routes />
        </Suspense>
      </AppContextProvider>
    )
  } catch (ex) {
    SentryClient.captureException(ex)
    return (
      <div>The application encountered an error.</div>
    )
  }
}

export default App
